import React from 'react';
import styled from 'styled-components';
import { Typography, Alert } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';

const ContentDialog = styled.div`
    max-width: 600px;
    min-width: 100%;

    .MuiAlert-root {
        margin-top: 20px;
    }
`;

export const ChangeProductDialog = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <ContentDialog>
            <Typography variant="body1" bodyVariant="onPaper">
                {t('changeproduct_to_marketing_info')}
            </Typography>
            <Alert severity="info" body={<>{t('changeproduct_to_marketing_alert')}</>} />
        </ContentDialog>
    );
};
